import { SystemState } from './types'

export const getNotes = (state: SystemState) => state.note.notes
